<template>
  <div id="success">
    <div class="content-wrapper">
      <div class="img-wrapper">
        <img width="100%" src="../assets/suc.png" alt="">
      </div>
      <div class="ml-20">
        <div class="success-tip">
        您的需求已提交成功，请等待服务商处理！
        </div>
        <div>你可以到<span class="link" @click="gotoMy()">我的定制</span>中查看进度！</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    gotoMy() {
      window.open('/fuwu/home/myCustom.action', '_blank');
    }
  }
}
</script>
<style scope>
#success {
  background: #ffffff;
  height: 400px;
}
.content-wrapper {
  display: flex;
  height: 300px;
  justify-content: center;
  align-items: center;
}
.img-wrapper {
  width: 50px;
  height: 50px;
}
.success-tip {
  font-size: 20px;
}
.link {
  color: #4285F4;
  cursor: pointer;
}
</style>